import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Contents from './contents';
import Admin from './Admin';
import Music from './Music';
import Creators from './Creators';
import Reviews from './Reviews';
import Home from './Home';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import { QueryProvider } from './QueryContext';
import { AuthProvider, PageViewTracker } from './AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import GuestOnly from './components/GuestOnly';

document.title = process.env.REACT_APP_ENV === 'development' ? 'Inhence - dev' : 'Inhence';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PageViewTracker />
        <QueryProvider>
          <Routes>
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/signup" element={<GuestOnly><SignUp /></GuestOnly>} />
            <Route path="/forgot-password" element={<GuestOnly><ForgotPassword /></GuestOnly>} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/contents" element={<ProtectedRoute require="viewer"><Contents /></ProtectedRoute>} />
            <Route path="/music" element={<ProtectedRoute require="viewer"><Music /></ProtectedRoute>} />
            <Route path="/creators" element={<ProtectedRoute require="viewer"><Creators /></ProtectedRoute>} />
            <Route path="/reviews" element={<ProtectedRoute require="viewer"><Reviews /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute require="admin"><Admin /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </QueryProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
